import React, { useMemo, useEffect, useState } from "react" 
import { useNavigate } from "react-router-dom"

import AddConnectedMaster from "./AddConnectedMaster" 
import { deleteNow } from "helpers/delete_function" 
import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import moment from "moment"
import { setUpdatedData } from "helpers/data_setters"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"

const AllConnectedMaster = ({ module_id }) => {

    const [table_data, settable_data] = useState([])
    const [loading, setLoading] = useState(false)
    const [client_type_options, setclient_type_options] = useState([])
    const [clients_options, setclients_options] = useState([])

    document.title = "Connected Master | Peacock Accountants Limited"

    useEffect(() => {
        (async () => {
            await getconnections();

            let options;
            options = await getOptions("client-type/active")
            setclient_type_options(options)

            options = await getOptions("client")
            setclients_options(options?.filter(c => c.clientType))
        })()

    }, [])

    const getconnections = async () => {
        try {
            setLoading(true)
            const response = await axiosbaseurl.get("/connected-client");
            if (response.data.success) {
                settable_data(response.data.data)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    // getting dropdown options common function
    async function getOptions(api) {
        try {
            const response = await axiosbaseurl.get(`/${api}`);
            if (response.data.success)
                return response.data.data;

            return false
        } catch (error) {
            console.log(error)
        }
    }

    // const table_data = [
    //     {
    //         id: 1,
    //         client_id: 15,
    //         connection_name: 'ABC DEF Group',
    //         status: 1,
    //         created_date: '05-09-2024'
    //     },
    //     {
    //         id: 2,
    //         client_id: 12,
    //         connection_name: 'PQR STW Group',
    //         status: 1,
    //         created_date: '15-10-2024'
    //     },
    // ];

    return (
        <>
            {loading && <Loader />}
            <TableComponent table_data={table_data}
                client_type_options={client_type_options}
                clients_options={clients_options}
                settable_data={settable_data}
                module_id={module_id}
            />
        </>
    )
}

const TableComponent = ({ table_data, client_type_options, clients_options, settable_data, module_id }) => {

    const [addShow, setAddShow] = useState(false);
    const [connection_id, setconnection_id] = useState(null);

    const navigate = useNavigate()

    const { checkAccess, permissions } = usePermissionData()

    const handleStatus = async (status, id) => {
        try {
            if (status) {
                const response = await axiosbaseurl.patch(`/connected-client/${id}/status`, { status });
                if (response.data.success) {
                    settable_data(prev => setUpdatedData(prev, response.data.data, "edit", "Status "))
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleDelete = async (id) => {
        try {
            const response = await axiosbaseurl.delete(`/connected-client/${id}`);
            if (response.data.success)
                settable_data(prev => setUpdatedData(prev, response.data.data, "delete"))
        } catch (error) {
            console.log(error)
            swal("", error.response.data.message || "Something went Wrong", "error")
        }
    }

    // columns
    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filterable: true,
                disableFilters: true,
                className: " text-center",
                Cell: cellProps => <span>{cellProps.row.index + 1}</span>
            },
            {
                Header: "Connection Name",
                accessor: "connectionName",
                disableFilters: true,
                filterable: true,
                // className: "text-center"
            },
            {
                Header: "Connection Code",
                accessor: "connectionCode",
                disableFilters: true,
                filterable: true,
                className: "text-center"
            },

            {
                Header: "Created At",
                accessor: "createdAt",
                disableFilters: true,
                filterable: true,
                // className: "text-center",
                Cell: cellProps => {
                    return (
                        <span>{moment(cellProps.row.original.createdAt).format("DD MMM YYYY | hh:mm A")}</span>
                    )
                },
            },
            {
                Header: "Status",
        disableSort: true,
                accessor: "status",
                disableFilters: true,
                filterable: true,
                className: "text-center",
                Cell: cellProps => {
                    return (
                        <div className="text-center">
                            <select
                                onChange={(e) => handleStatus(e.target.value, cellProps.row.original.id)}
                                disabled={!checkAccess(module_id, "edit")}
                                className={`badge fs-6 border-0 status_select_dropdown 
                                    bg-${cellProps.row.original.status == "Active" ? "green" : "danger"}`}
                                value={cellProps.row.original.status}>
                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>
                            </select>
                        </div>
                    )
                },
            },
            {
                Header: "Action",
                disableFilters: true,
                disableSort: true,
                accessor: "view",
                className: "col-2 text-center",
                Cell: cellProps => {
                    return (
                        <div>
                            {
                                checkAccess(module_id, 'edit') &&
                                <button
                                    onClick={() => {
                                        setAddShow(true)
                                        setconnection_id(cellProps.row.original.id)
                                    }}
                                    className="btn btn-success bg-green  btn-sm me-2"
                                >
                                    <i className="fas fa-pen me-1"></i> Edit
                                </button>
                            }

                            {/* {
                                checkAccess(module_id, 'remove') &&
                                <button
                                    onClick={() => deleteNow(() => handleDelete(cellProps.row.original.id))}
                                    className="btn btn-danger btn-sm ml-10" >
                                    <i className="fas fa-trash-alt"></i>
                                </button>
                            } */}
                        </div>
                    )
                },
            },
        ],
        [permissions]
    )

    // table data
    const data = useMemo(() => (table_data), [table_data]) 

    return (
        <>
            <PermittedComponent isAccess={checkAccess(module_id, "view")}>
                <CommonTable
                    columns={columns}
                    data={data}
                    heading={"Connections"}
                >
                    <div>
                        {
                            checkAccess(module_id, 'add') &&
                            <button onClick={() => setAddShow(true)} className="btn btn-primary bg-blue ms-3">
                                <i className="fas fa-plus me-2"></i>
                                Add Connection
                            </button>
                        }

                        <button onClick={() => navigate(-1)} className="btn btn-secondary bg-dark ms-3">
                            <i className="fas fa-arrow-left me-3"></i>
                            Back
                        </button>
                    </div>
                </CommonTable> 

                <AddConnectedMaster show={addShow} setShow={setAddShow}
                    client_type_options={client_type_options}
                    clients_options={clients_options}
                    settable_data={settable_data}
                    connection_id={connection_id}
                    setconnection_id={setconnection_id}
                /> 
            </PermittedComponent>

        </>
    )
}

export default AllConnectedMaster
